import React, { Component } from 'react'

import { Button, Grid } from '@mui/material'
import CustomerNewForm from 'features/customers/components/create/CustomerNewForm'
import { planLabel } from 'features/customers/constants/planLabels'
import { usePlans } from 'features/customers/hooks/usePlans'
import debounce from 'lodash/debounce'

import { FormSelect, FormTextField } from 'components/input'
import FormToggle from 'components/input/FormToggle'
import { withForm } from 'decorators/withForm'

const MODALS = {
  add: 'add',
}

const CODE_STATUS_OPTIONS = Object.entries({
  collecting: 'Collecting',
  not_collecting: 'Not Collecting',
  unknown: 'Unknown',
}).map(([value, label]) => ({ value, label }))

type CustomersFiltersFormProps = {
  onHandleModalClose: (...args: any[]) => any
  onHandleModalOpen: (...args: any[]) => any
  modal?: string
}

const CustomersFiltersForm = ({ modal, onHandleModalOpen, onHandleModalClose }: CustomersFiltersFormProps) => {
  const { data: plans = [] } = usePlans()

  const planOptions = plans.map((plan: any) => ({ value: plan.id, label: planLabel(plan.name) }))

  return (
    <Grid container spacing={2} style={{ width: '100%' }} sx={{ alignItems: 'center', justifyContent: 'flex-end' }}>
      <Grid style={{ width: 210 }}>
        <FormSelect label="Plan" multiple name="plan_id" options={planOptions} />
      </Grid>
      <Grid style={{ width: 190 }}>
        <FormTextField
          slotProps={{ htmlInput: { min: 1, step: 1 } }}
          label="Customer ID"
          name="id"
          normalize={(value: any) => value || ''}
          type="number"
        />
      </Grid>
      <Grid style={{ width: 210 }}>
        <FormSelect label="Code Status" name="code_status" options={CODE_STATUS_OPTIONS} />
      </Grid>
      <Grid>
        <FormToggle
          component="switch"
          label="Manual Approval"
          name="workflowManualApproval"
          tooltip="Manual approval - Customers that need special care and exceptional data quality"
        />
      </Grid>
      <Grid>
        <FormToggle component="switch" label="Deleted" name="showDeleted" tooltip="Show deleted customers" />
      </Grid>
      <Grid style={{ width: 300, minWidth: 200 }}>
        <FormTextField name="search" placeholder="Search..." />
      </Grid>
      <Grid>
        <Button onClick={onHandleModalOpen(MODALS.add)}>Create</Button>
      </Grid>
      <CustomerNewForm onClose={onHandleModalClose} open={modal === MODALS.add} />
    </Grid>
  )
}

type CustomersFiltersProps = {
  setFilters: (...args: any[]) => any
}

type CustomersFiltersState = {
  modal: string | null
}

class CustomersFilters extends Component<CustomersFiltersProps, CustomersFiltersState> {
  state: CustomersFiltersState = {
    modal: null,
  }

  handleModalOpen = (modal: string) => () => this.setState({ modal })

  handleModalClose = () => this.setState({ modal: null })

  render() {
    const { modal } = this.state
    return (
      <CustomersFiltersForm
        modal={modal ?? undefined}
        onHandleModalClose={this.handleModalClose}
        onHandleModalOpen={this.handleModalOpen}
      />
    )
  }
}

export default withForm({
  form: 'customerFilters',
  onChange: debounce((values: any, _dispatch: any, props: any) => props.setFilters(values), 500),
})(CustomersFilters)
